import React, { ReactElement, useState, createContext } from "react";
import { TemplateObject } from "../Models/TemplateObject";

const InputContext = createContext<{
  conditionalInput: null | TemplateObject;
  setConditionalInput: Function;
  stepSlugOverride?: string | null;
  setStepSlugOverride: (s?: string | null) => void;
  disableAutoAdvance?: boolean;
}>({
  conditionalInput: null,
  setConditionalInput: (value: TemplateObject) => {},
  stepSlugOverride: null,
  setStepSlugOverride: (s?: string | null) => {},
  disableAutoAdvance: false,
});

type Props = {
  children: React.ReactNode;
};

type ProviderProps = Props & {
  initialStepSlug?: string | null;
  disableAutoAdvance?: boolean;
};

export const InputContextProvider = ({
  children,
  initialStepSlug = null,
  disableAutoAdvance = false,
}: ProviderProps): ReactElement => {
  const [conditionalInput, setConditionalInput] =
    useState<null | TemplateObject>(null);
  const [stepSlugOverride, setStepSlugOverrideState] = useState<string | null>(
    initialStepSlug || null
  );
  const setStepSlugOverride = (s?: string | null) =>
    setStepSlugOverrideState(s === undefined ? null : s);
  return (
    <InputContext.Provider
      value={{
        conditionalInput,
        setConditionalInput,
        stepSlugOverride,
        setStepSlugOverride,
        disableAutoAdvance,
      }}
    >
      {children}
    </InputContext.Provider>
  );
};

export default InputContext;
